<template>
    <v-list dense >
      <v-subheader v-if="reformattedSearchString">
          {{ sirets.length }} résultats <span v-if="!isAdvanced"> pour "{{reformattedSearchString}}"</span>
      </v-subheader>
       <v-list-item-group v-model="selectedItemNum" color="primary">
          <siret-item  v-for="siret in sirets" :siret="siret" :key="siret.siret"  @click.native="displaySelected(siret)">{{siret.siret}}</siret-item>
      </v-list-item-group>

    </v-list>

</template>

<script>
//import SiretItem from "./SiretItem";

import SiretItem from "@/components/freeSearch/SiretItem";
export default {
  name: "SearchResults",
  components: {
    SiretItem
  },
  data() {
    return {
      title: "Search Results",
      displayMode: "grid",
      selectedItemNum: 0,
    };
  },
  props: ["sirets", "reformattedSearchString"],
  methods: {
    /**
     * update state to maintain selected item
     * and toggle view
     */
    displaySelected(selectedItem) {
      //this.selectedItemNum = index
      this.$store.dispatch('getEtablissement',selectedItem.siret, selectedItem)
    },

      isAdvanced() {
        return this.$store.state.searchType == "advancedSearch"
      }
  }

};
</script>

<style scoped>
button:focus {
  box-shadow: none !important;
}
</style>
